import { createAction } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'companion-app-components/flux/root-ui';

import { DIALOG_TYPE as DIALOG_TYPE_WF_DESKTOP_FEATURES } from './types';

export const doAdditionalDesktopFeatures = createAction(
  rootUiActions.createDialog.toString(),
  () => rootUiTypes.mkRootUiData({
    id: 'WFDesktopFeatures',
    type: DIALOG_TYPE_WF_DESKTOP_FEATURES,
    allowNesting: false,
  }),
);
